<script setup>
import { onMounted, ref } from 'vue';
import reward_item from './reward_item.vue';
import card_header from '@/components/card_header'
import { get_histories, get_total_reward } from '@/services/rewards';
import { swalError } from '@/helper';

const isLoading = ref(true)
const reward_histories = ref([])
const totalPoints = ref(0)

onMounted(async ()=>{
  await Promise.all([
    retrieve_histories(),
    retrieve_total()
  ])
  isLoading.value = false
})

async function retrieve_histories(){
  let response = await get_histories()
  if (response.error){
    swalError(response.result, true)
    return
  }
  reward_histories.value = response.result.data.data
}

async function retrieve_total(){
  let response = await get_total_reward()
  if (!response.error){
    totalPoints.value = response.result.data.total_points || 0
  }
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Point History"/>
    
    <div class="row">
      <!-- Total Points Card -->
      <div class="col-12 mb-4">
        <div class="card bg-primary text-white overflow-hidden">
          <div class="card-body p-4 position-relative">
            <div class="d-flex align-items-center justify-content-between position-relative z-index-1">
              <div>
                <h5 class="text-white-50 mb-2">Total Points Available</h5>
                <h2 class="display-4 fw-bold mb-0">{{ totalPoints }}</h2>
              </div>
              <div class="p-3 bg-white bg-opacity-25 rounded-circle">
                <vue-feather type="award" size="3rem"></vue-feather>
              </div>
            </div>
            <!-- Decorative circles -->
            <div class="position-absolute top-0 end-0 p-5 bg-white opacity-10 rounded-circle translate-middle-y me-n5 mt-n5" style="width: 200px; height: 200px;"></div>
            <div class="position-absolute bottom-0 start-0 p-5 bg-white opacity-10 rounded-circle translate-middle-x ms-n5 mb-n5" style="width: 150px; height: 150px;"></div>
          </div>
        </div>
      </div>

      <!-- History List -->
      <div class="col-12">
        <div class="card">
          <card_header title="Transaction History"/>
          <div class="card-body">
            <loadingCard v-if="isLoading" loadingType="item" />
            <template v-else>
              <EmptyCard v-if="reward_histories.length == 0" 
                text="No point history yet"
                desc="Complete assessments and interventions to earn points!"
              />
              <div v-else class="timeline-container">
                <template v-for="(history, index) in reward_histories" :key="history.id">
                  <reward_item :history="history" :index="index" /> 
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.z-index-1 {
  z-index: 1;
}
.opacity-10 {
  opacity: 0.1;
}
</style>